"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReminderEmailDto = void 0;
class ReminderEmailDto {
}
exports.ReminderEmailDto = ReminderEmailDto;
//# sourceMappingURL=reminder-email-dto.js.map